import React from "react";
import {
  FaRobot,
  FaExchangeAlt,
  FaHistory,
  FaShieldAlt,
  FaBell,
  FaWallet,
} from "react-icons/fa";

function Backtesting() {
  return (
    <>
      <div
        className="process-style-two-area overflow-hidden bg-cover default-padding bg-dark text-light"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-20.jpg)",
        }}
      >
        <div className="container">
          <div className="site-heading">
            <div className="row align-center">
              <div className="col-lg-6">
                <h4 className="sub-title">Our Process</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Stunning Features of Our Crypto Arbitrage Trading Bot
                </h2>
              </div>
              <div className="col-lg-5 offset-lg-1">
                <p>
                  Check out some of the stunning features of our crypto
                  arbitrage bot development solutions listed below.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="process-style-two-items">
            <div className="row">
              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaRobot size={40} color="#3b82f6" />
                  </div>
                  <h4>Automated Trading</h4>
                  <p>
                    Our arbitrage trading bots are completely automated and are
                    crafted to make proper trading decisions. The crypto
                    arbitrage bots can be configured to track different crypto
                    exchanges and automatically place trade orders.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaExchangeAlt size={40} color="#3b82f6" />
                  </div>
                  <h4>Arbitrage Trading</h4>
                  <p>
                    Our crypto arbitrage bot development solutions allow users
                    to conveniently configure their bots to carry out arbitrage
                    trading as per their bespoke strategy, allowing them to make
                    better profits in changing market conditions.
                  </p>
                  <br />
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaHistory size={40} color="#3b82f6" />
                  </div>
                  <h4>Backtesting</h4>
                  <p>
                    Users can easily and conveniently backtest their customized
                    strategies with the help of the trading bots to ensure the
                    strategies’ potential as well as accuracy before entering
                    into live trading activities.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaShieldAlt size={40} color="#3b82f6" />
                  </div>
                  <h4>Stop Loss</h4>
                  <p>
                    Crypto arbitrage trading bots developed by our team allow
                    users to modify and edit their existing trades at the time
                    of active trading sessions with the help of the integrated
                    stop-loss feature in the bots.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaBell size={40} color="#3b82f6" />
                  </div>
                  <h4>Push Notifications</h4>
                  <p>
                    Our crypto trading bot development solutions come with the
                    feature of push notifications that allow users to get live
                    updates regarding profits, signals, losses, and many more as
                    per their preferences.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaWallet size={40} color="#3b82f6" />
                  </div>
                  <h4>Crypto Portfolio</h4>
                  <p>
                    The crypto portfolio feature allows users to easily track
                    their spending, active trading, the success of PNLs, cancel
                    trades, and several other things that provide them with a
                    clear picture of their activities.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Backtesting;
